import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const overflowWrap = system({
    overflowWrap: true,
});

export interface OverflowWrapProps<ThemeType extends Theme = RequiredTheme> {
    overflowWrap?: ResponsiveValue<CSS.Property.OverflowWrap, ThemeType> | undefined;
}
